/**
 * Char used to separate C2S and S2C payload elements.
 */
export const PayloadSeparator = '|';

export enum ClientOpCode {
  Echo = 1,

  /**
   * Slot building build request.
   * Payload: [Building Id, Slot Id]
   */
  Build,

  /**
   * Player and tribe name change request.
   * Payload: [Player Name, Tribe Name]
   */
  NameChange,

  /**
   * Train troops request.
   * Payload: [SlotIndex, Troop Id, Count]
   */
  TrainTroops,

  /**
   * Recruit hero request.
   * Payload: [optional consumables that increase the chance for higher stars or better effects] 
   */
  RecruitHero,

  /**
   * Dismiss players hero.
   * Payload: [Hero Id]
   */
  DismissHero,

  /**
   * Send hunting group to attack.
   * Payload: [ TargetType, Location Id | instance location id | village id, HeroId, ITroopGroup[] ]
  */
  Attack,

  /**
   * Collect items attached to email.
   * Payload: [Email Id]
   */
  CollectEmail,

  /**
   * Dismiss email (set isRead to true).
   * Payload: [Email Id]
   */
  DismissEmail,

  /**
   * Collect daily reward.
   */
  CollectDailyReward,

  /**
   * Consumes hero xp into hero effect upgrades.
   * Payload: [Hero Id]
   */
  DistributeHeroXp,

  /**
 * Consumes hero xp and ascension material to increase the number of 
 * stars by 1 and and move all effect values into the next star level.
 * Payload: [Hero Id]
 */
  HeroAscension,

  ChatMessage,
}

export enum ServerOpCode {
  /// <summary>
  /// Echo for debugging only
  /// </summary>
  Echo = 0,

  /// <summary>
  /// Server sends initial state to client (sent on client connect).
  /// State contains complete user and world data.
  /// </summary>
  GameData,

  /// <summary>
  /// Server sends local player state.
  /// </summary>
  PlayerState,

  /// <summary>
  /// Server sends ISharedPlayer data to all connected clients.
  /// </summary>
  PlayerCreated,

  /// <summary>
  /// Server sends ISharedPlayer data to all connected clients to inform them about player or tribe name change.
  /// </summary>
  PlayerNameChanged,

  /// <summary>
  /// Server sends battle report id, result to player.
  /// Payload: [type, title, message]
  /// The battle report id contains: playerId:heroId:targetType:targetId:timestamp
  /// </summary>
  ServerNotification,

  /// <summary>
  /// Server sends a chat message to local player.
  /// Payload: [Utc, Channel id, Sender id, Message]
  /// </summary>
  ChatMessage,

  /// <summary>
  /// Send to client if a command has invalid payload.
  /// Payload: [error message]
  /// </summary>
  FormatError,

  /// <summary>
  /// Send to client if a command can not be executed due to invalid game state. e.g. not enough resources.
  /// Payload: [error message]
  /// </summary>
  StateError,

  /// <summary>
  /// Generic error message.
  /// </summary>
  Error = 1024,
}
